import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            Browse by Category
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            Explore our organized Kakobuy Spreadsheet categories and discover verified products across every style.
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3 md:gap-4">
          {categories.map((cat, index) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col items-center gap-2.5 p-4 md:p-5 rounded-xl bg-background-100 hover:bg-background-200/80 transition-all cursor-pointer"
            >
              <span className="w-10 h-10 md:w-11 md:h-11 rounded-lg bg-background-50 flex items-center justify-center group-hover:scale-105 transition-transform">
                <i className={`${cat.icon} text-foreground-700 text-base md:text-lg`}></i>
              </span>
              <span className="text-xs md:text-sm text-foreground-700 font-medium text-center leading-tight whitespace-nowrap">
                {cat.name}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}